import "../styles/RegulatoryCompliance.css";

const CTASection = ({ onClick }) => {
  return (
    <div className="cta-box">
      <h2 className="cta-head">Ready to Start?</h2>
      <p className="cta-text">
        Talk to us today and let’s design a solution that fits your vision.
      </p>
      <a href="mailto:info@nexagrowthafrica.com">
        <button className="cta-button" onClick={onClick}>
          Book a free consultation
        </button>
      </a>
    </div>
  );
};

export default CTASection;
